import styled from "styled-components";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import PhotoAlbum from "react-photo-album";
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useMediaQuery } from "react-responsive";

const Container = styled.div``;

const photos = [
  { src: "/portfolio/all/artist-portfolio-1.jpg", width: 1536, height: 1920 },
  { src: "/portfolio/all/artist-portfolio-2.jpg", width: 1920, height: 1280 },
  { src: "/portfolio/all/artist-portfolio-3.jpg", width: 1620, height: 1620 },
  { src: "/portfolio/all/artist-portfolio-4.jpg", width: 1620, height: 1620 },
  { src: "/portfolio/all/artist-portfolio-5.jpg", width: 720, height: 900 },
  { src: "/portfolio/all/artist-portfolio-6.jpg", width: 1620, height: 1620 },
  { src: "/portfolio/all/artist-portfolio-7.jpg", width: 1621, height: 1621 },
  { src: "/portfolio/all/artist-portfolio-8.jpg", width: 720, height: 1280 },
  { src: "/portfolio/all/artist-portfolio-9.jpg", width: 1620, height: 1621 },
  { src: "/portfolio/all/artist-portfolio-10.jpg", width: 1620, height: 1620 },
  { src: "/portfolio/all/artist-portfolio-11.jpg", width: 1440, height: 1800 },
  { src: "/portfolio/all/artist-portfolio-12.jpg", width: 1440, height: 1800 },
];

const Gallery = () => {
  const [index, setIndex] = useState(-1);

  const isTablet = useMediaQuery({ query: "(min-width: 768px)" });
  return (
    <Container>
      <PageHeader title="Galéria" />
      <PhotoAlbum
        layout="rows"
        targetRowHeight={isTablet ? 500 : 200}
        photos={photos}
        onClick={({ index }) => setIndex(index)}
      />
      <Lightbox
        slides={photos}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
      <Footer />
    </Container>
  );
};

export default Gallery;
